import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UsersRoutingModule } from './users-routing.module';
import { UserGroupDetailComponent } from './user-groups/user-group-detail/user-group-detail.component';
import { UserGroupListComponent } from './user-groups/user-group-list/user-group-list.component';
import { UserDataDetailComponent } from './user-datas/user-data-detail/user-data-detail.component';
import { UserDataListComponent } from './user-datas/user-data-list/user-data-list.component';
import { UserDataPartnerDetailComponent } from './user-datas-partner/user-data-partner-detail/user-data-partner-detail.component';
import { UserRoleDetailComponent } from './user-roles/user-role-detail/user-role-detail.component';
import { UserRoleListComponent } from './user-roles/user-role-list/user-role-list.component';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components';
import { TranslateModule } from '@ngx-translate/core';
import { BrandIdentificationComponent } from './user-datas/user-data-detail/brand-identification/brand-identification.component';
import { ConserveEcologyComponent } from './user-datas/user-data-detail/conserve-ecology/conserve-ecology.component';
import { EconomicAspectComponent } from './user-datas/user-data-detail/economic-aspect/economic-aspect.component';
import { SeedingProgramComponent } from './user-datas/user-data-detail/seeding-program/seeding-program.component';
import { SocialAspectComponent } from './user-datas/user-data-detail/social-aspect/social-aspect.component';
import { WorkerSafetyComponent } from './user-datas/user-data-detail/worker-safety/worker-safety.component'; 
import { TrainningComponent } from './user-datas/user-data-detail/training/trainning.component';

@NgModule({
  declarations: [
    UserGroupDetailComponent,
    UserGroupListComponent,
    UserDataDetailComponent,
    UserDataListComponent,
    UserDataPartnerDetailComponent,
    UserRoleDetailComponent,
    UserRoleListComponent,
    BrandIdentificationComponent,
    ConserveEcologyComponent,
    EconomicAspectComponent,
    SeedingProgramComponent,
    SocialAspectComponent,
    WorkerSafetyComponent,
    TrainningComponent,
  ],
  imports: [
    CommonModule,
    UsersRoutingModule,
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    TranslateModule,
  ],
  exports: [
    UserDataDetailComponent,
    UserDataPartnerDetailComponent,
    UserDataListComponent,
  ]
})
export class UsersModule { }
